export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看模板',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑模板',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    data: {},
  },
  {
    text: that.$l('menu_text_copy') || '复制模板',
    icon: 'el-icon-document-copy',
    menuType: 'copy',
    divided: false,
    allow: 'C',
    data: {},
  },
  {
    text: that.$l('menu_text_delete') || '删除模板',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    allow: 'D',
    data: {},
  }
  ,
  {
    text: that.$l('menu_text_subscribe') || '订阅模板',
    icon: 'el-icon-message',
    menuType: 'subscribe',
    divided: true,
    allow: 'S',
    data: {},
  }
]
